<script setup lang="ts">
import { computed } from 'vue';
import EGSButton from '@/components/Button/EGS_Button.vue';
import EGSDialog from '@/components/Dialog/EGS_Dialog.vue';
import { confirmationActions, confirmationState } from '@/composables/useConfirm.ts';

defineOptions({ name: 'EGS_ConfirmDialog' });
const message = computed(() => confirmationState.value);
function iconValue(): [string, string] {
	const icon = message.value?.icon;
	if (Array.isArray(icon)) return [String(icon[0]), String(icon[1])];
	return ['fas', typeof icon === 'string' ? icon : 'circle-question'];
}
</script>

<template>
	<EGSDialog :modelValue="Boolean(message)" :title="message?.header || 'Confirm'" widthClass="max-w-[30rem]" :closeOnOverlay="true" @update:modelValue="!$event && confirmationActions.reject()">
		<div v-if="message" class="flex items-start gap-3">
			<font-awesome-icon :icon="iconValue()" class="mt-0.5 shrink-0 text-2xl text-amber-600" />
			<p class="text-sm leading-6">{{ message.message }}</p>
		</div>
		<template v-if="message" #footer>
			<EGSButton v-bind="message.rejectProps" :label="message.rejectLabel || 'Cancel'" :class="message.rejectClass" severity="secondary" outlined @click="confirmationActions.reject" />
			<EGSButton v-bind="message.acceptProps" :label="message.acceptLabel || 'Yes'" :class="message.acceptClass" @click="confirmationActions.accept" />
		</template>
	</EGSDialog>
</template>
